import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { openSMSWidget, popupOpenClose } from "../../../action/action";
import { sendAnalytics } from "../../../action/homeAction";
import { CLICKED } from "../../../config/constant";
import { setGoHome } from "../../action/homeAction";
import { getDefaultAnalyticsLabel } from "../../JS/utility";


const SendNativeSMS = (props) => {

    const { t } = props
    const room = localStorage.getItem("room");
    const currentGuestDetails = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));
    const [msg, setMsg] = React.useState("")
    const [number, setNumber] = React.useState("")
    const [isChecked, setIsChecked] = React.useState(false);
    const [renderPopup, setRenderPopup] = React.useState(false);


    const sendSms = () => {

        if (window.device) {

            if (isChecked) {
                localStorage.setItem("doNotShowSMSPopup", true)
            }

            //CONFIGURATION
            const options = {
                replaceLineBreaks: true, // true to replace \n by a new line, false by default
                android: {
                    intent: 'INTENT'  // send SMS with the native android SMS messaging
                    //intent: '' // send SMS without opening any other app, require : android.permission.SEND_SMS and android.permission.READ_PHONE_STATE
                }
            };


            window.sms.send(number.toString(), msg, options, successSendingSMS, errorSendingSMS);
        } else {
            if (isChecked) {
                localStorage.setItem("doNotShowSMSPopup", true)
            }

            let checkiOS = /iPad|iPhone|MacIntel|iPod/.test(window.navigator.platform);

            let smsLink;
            if(checkiOS){
                smsLink = `sms:${number.toString()}&body=${encodeURIComponent(msg)}`;
            } else {
                smsLink = `sms:${number.toString()}?body=${encodeURIComponent(msg)}`;
            }
    
            window.open(smsLink);

            setTimeout(() => {
                props.openSMSWidget(false);
                props.setGoHome(true);
            }, 1000);
        }
    }

    const successSendingSMS = () => {
        props.openSMSWidget(false);
        props.setGoHome(true);
    }

    const errorSendingSMS = (e) => {
        props.openSMSWidget(false);
        if(e.toLowerCase() != "message cancelled.") { props.popupOpenClose(true, e ? 'Something went wrong:' + e : "Error opening native SMS app") }
        props.setGoHome(true);
    }

    const openSMS = () => {
        const doNotShowSMSPopup = localStorage.getItem("doNotShowSMSPopup")

        if (!doNotShowSMSPopup) {
            setRenderPopup(true);
        } else {
            sendSms();
        }

    }

    React.useEffect(() => {

        let preFilledMsg;

            if (room && room !== "null") {
                preFilledMsg = props.currentWidget.widgetMessageLoggedIn ? currentGuestDetails[0].guestProfile.firstName ? props.currentWidget.widgetMessageLoggedIn.replace("#ROOMNUMBER", room).replace("#GUESTNAME", currentGuestDetails[0].guestProfile.firstName + " " + currentGuestDetails[0].guestName).replace("</br>", "\n").replace("<br>", "\n") : props.currentWidget.widgetMessageLoggedIn.replace("#ROOMNUMBER", room).replace("#GUESTNAME", currentGuestDetails[0].guestName).replace("</br>", "\n").replace("<br>", "\n") : null
            } else {
                preFilledMsg = props.currentWidget.widgetMessage && props.currentWidget.widgetMessage.replace("</br>", "\n").replace("<br>", "\n");
            }

            setMsg(preFilledMsg)
            setNumber(props.currentWidget.widgetPhone)

        let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })

        props.sendAnalytics(
            props.guestDetail || null,
            props.currentWidget.widgetType == "Floating Widget" ? props.currentWidget.widgetTypeName : props.currentWidget.widgetType ,
            CLICKED,
            { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget"},
            0,
            props.guestIsLoggedIn
        );
    }, [])

    React.useEffect(() => {
        if(number) openSMS();
    },[number])

    return renderPopup && (
        <div>
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{ color: "#000 !important" }}>{t('smsMessage.heading')}</h2>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-envelope"></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-content">
                            <p>{t('smsMessage.warning')}</p>
                        </div>
                        {(window.device || (window.navigator.userAgent &&  window.navigator.userAgent.indexOf('Chrome') != -1 ? true : window.navigator.userAgent.indexOf('Safari') == -1)) && <div class="overlay-controls">
                            <input id="acceptSms" type="checkbox" name="acceptSms" checked={isChecked} onChange={(event) => setIsChecked(event.target.checked)} />
                            <label for="acceptSms" style={{ marginLeft: "1rem" }} >{t('smsMessage.checkBoxLabel')}</label>
                        </div>}
                        <div class="overlay-controls">
                            <button onClick={() => sendSms()} class="button">{t('smsMessage.sendButton')}</button>
                            <button onClick={() => {props.openSMSWidget(false); props.setGoHome(true);}} class="button secondary">{t('smsMessage.closeButton')}</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidget: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { popupOpenClose, setGoHome, openSMSWidget, sendAnalytics, getDefaultAnalyticsLabel })(withTranslation('translations')(SendNativeSMS));